/**
 * @ngdoc factory
 * @description Makes overlays based on input.
 * @param EcourseFactory
 * @param $state
 * @param $stateParams
 * @returns {{nextOverlay: nextOverlay, resumeCourseOverlay: resumeCourseOverlay, redirectOverLay: redirectOverLay}}
 * @constructor
 * @param Ecourses
 */
export default function OverlayFactory(Ecourses, EcourseFactory, $state) {
  'ngInject';
  
  function redirectOverLay() {
    return {
      template: 'ecourseRedirect'
    };
  }

  function nextOverlay(ecourse, newSegment = false, currentSegment, currentMedia) {
    if (EcourseFactory.ecourseComplete(ecourse.userData.progress)) {
      return completeOverlay(ecourse);
    }
    //Get the next data
    let {segment: nextSegment, media: nextMedia} = EcourseFactory.nextInOrder(ecourse, currentSegment, currentMedia);

    if(nextSegment.slug !== currentSegment.slug) {
      //Segment is complete, show complete segment overlay.
      return nextSegmentOverlay(currentSegment, nextSegment, nextMedia, newSegment);
    }

    //Video is complete but there are more videos to watch within segment.
    return nextVideoOverlay(currentSegment, nextMedia);
  }


  function resumeCourseOverlay(ecourse) {
    if (EcourseFactory.ecourseComplete(ecourse.userData.progress)) {
      return completeOverlay(ecourse);
    }
    let {segment: nextSegment, media: nextMedia} = EcourseFactory.next(ecourse);
    if (EcourseFactory.progressPristine(ecourse.userData.progress)) {
      return startFirstSegmentOverlay(nextSegment, nextMedia);
    }
    else {
      return {
        hideContent: false,
        template: 'resumeCourse',
        link: buildState(nextSegment, nextMedia)
      };
    }
  }

  //Private
  function buildState(nextSegment, nextMedia) {
    let redirectParams;
    if (nextMedia) {
      redirectParams = {segment: nextSegment.slug, media: nextMedia.id, play: true};
    }
    else {
      redirectParams = {segment: nextSegment.slug};
    }
    return () => {
      $state.go('app.ecourse.segment', redirectParams);
    };
  }

  function completeOverlay(ecourse) {
    return {
      template: 'ecourseComplete',
      link: () => {
        Ecourses.syncProgress(ecourse, true).then(function() {
          $state.go('app.ecourse.overview', {slug: ecourse.slug}, {reload: true});
        });
      }
    };
  }

  function nextVideoOverlay(nextSegment, nextMedia) {
    return {
      template: 'nextVideo',
      message: nextMedia.message,
      link: buildState(nextSegment, nextMedia),
      data: {
        nextMedia
      }
    };
  }

  function nextSegmentOverlay(currentSegment, nextSegment, nextMedia = undefined, currentSegmentComplete) {
    let template;
    if (EcourseFactory.segmentAvailable(nextSegment)) {
      template = 'nextSegment';
    }
    else {
      template = 'nextSegmentNotAvailable';
    }
    return {
      template,
      link: buildState(nextSegment, nextMedia),
      data: {
        currentSegment,
        nextSegment,
        currentSegmentComplete
      }
    };
  }

  function startFirstSegmentOverlay(nextSegment, nextMedia) {

    return {
      template: 'startFirstSegment',
      link: buildState(nextSegment, nextMedia),
      message: nextMedia.message,
      data: {
        nextSegment,
        nextMedia
      }
    };
  }

  return {
    nextOverlay,
    resumeCourseOverlay,
    redirectOverLay
  };
}



/** WEBPACK FOOTER **
 ** ./src/app/ecourse/shared/overlays/overlay.factory.js
 **/